import { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

/**
 * Modal to select a driver from a list
 * @param {object} props
 * @param {boolean} props.open - Controls if the modal is open
 * @param {function} props.onClose - Function to call when the modal closes
 * @param {Array<{id: number, user: {full_name: string}}>} props.drivers - List of available drivers
 * @param {function(number): void} props.onConfirm - Function called with the selected driver's ID on confirmation
 * @param {boolean} [props.loading=false] - Shows a loading state
 */

const SelectDriverModal = ({
  open,
  onClose,
  onConfirm,
  drivers = [],
  loading = false,
}) => {
  const [selectedDriverId, setSelectedDriverId] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedDriverId(null);
    }
  }, [open]);

  const handleConfirm = () => {
    if (selectedDriverId) {
      onConfirm(selectedDriverId);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Seleccionar Driver</DialogTitle>
      <DialogContent sx={{ width: '100%' }}>
        <FormControl fullWidth sx={{ mt: 2 }}>
          <InputLabel id="select-driver-label">Driver</InputLabel>
          <Select
            labelId="select-driver-label"
            id="driver-select"
            value={selectedDriverId}
            label="Driver"
            onChange={(e) => setSelectedDriverId(e.target.value)}
            disabled={loading}
            fullWidth
          >
            <MenuItem value="" disabled>
              <em>Selecciona un driver...</em>
            </MenuItem>
            {drivers.map((driver) => (
              <MenuItem key={driver.id} value={driver.id}>
                {driver.full_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={!selectedDriverId || loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectDriverModal;
